import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#04BF7B',
      light: '#34D89E',
      dark: '#038C5A',
    },
    secondary: {
      main: '#2A3447',
      light: '#3A4559',
      dark: '#1A2133',
    },
    text: {
      primary: '#2A3447',
      secondary: '#475569'
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8FAFC'
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: '-0.02em',
      lineHeight: 1.1
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      lineHeight: 1.2
    },
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      lineHeight: 1.3
    },
    body1: {
      fontSize: '1.125rem',
      lineHeight: 1.7,
      color: '#475569'
    },
    body2: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#475569'
    }
  },
  spacing: (factor: number) => `${0.5 * factor}rem`,
  shape: {
    borderRadius: 12
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          lineHeight: 1.5,
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
          }
        }
      }
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: '100% !important',
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          '@media (min-width: 600px)': {
            paddingLeft: '2rem',
            paddingRight: '2rem'
          },
          '@media (min-width: 960px)': {
            paddingLeft: '2.5rem',
            paddingRight: '2.5rem'
          }
        }
      }
    }
  }
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#04BF7B',
      light: '#34D89E',
      dark: '#038C5A',
    },
    secondary: {
      main: '#2A3447',
      light: '#3A4559',
      dark: '#1A2133',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#94A3B8'
    },
    background: {
      default: 'rgb(20, 25, 30)',
      paper: 'rgb(42, 52, 71)'
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: '-0.02em',
      lineHeight: 1.1
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      lineHeight: 1.2
    },
    h3: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      lineHeight: 1.3
    },
    body1: {
      fontSize: '1.125rem',
      lineHeight: 1.7,
      color: '#94A3B8'
    },
    body2: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#94A3B8'
    }
  },
  spacing: (factor: number) => `${0.5 * factor}rem`,
  shape: {
    borderRadius: 12
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          lineHeight: 1.5,
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
          }
        }
      }
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: '100% !important',
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          '@media (min-width: 600px)': {
            paddingLeft: '2rem',
            paddingRight: '2rem'
          },
          '@media (min-width: 960px)': {
            paddingLeft: '2.5rem',
            paddingRight: '2.5rem'
          }
        }
      }
    }
  }
});
